export default __webpack_public_path__ + "static/karinbauer-fd1b48d5d99f02ed4f1eb2f662bc1fc0.jpg";